import "./payrollStyle.css";
import React, { useEffect, useState, useCallback, useRef } from "react";
import { Col, Row, Form } from "react-bootstrap";
import ButtonCom from "../../../components/button/button";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";

import { getCalendarMonthListPath } from "../../../services/config";
import { commonGetData } from "../../../redux/slices/commonSlice";

const Index = () => {
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);
  const [calendarMonthList, setCalendarMonthList] = useState([]);

  const getAllowance = useCallback(() => {
    dispatch(commonGetData(getCalendarMonthListPath));
  }, []);

  useEffect(() => {
    getAllowance();
  }, []);
  useEffect(() => {
    if (commonState.commonGetSuccess) {
      setCalendarMonthList(commonState.commonGetData);
    }
  }, [commonState.commonGetSuccess]);

  const [isOpen, setIsOpen] = useState(false);

  const dropdownFunc = () => {
    setIsOpen((prev) => !prev);
  }

  const handleCalendarMonthList = (id, name) => {
    document.querySelector(".selected-display").innerHTML = name;
  };

  const handleStartDate = (e) => {
    let { value } = e.target;
    if (value == 1) {
      document.querySelector(".start-date").value = 31;
    } else {
      document.querySelector(".start-date").value = value - 1;
    }
  };

  return (
    <div className="payroll-container">
      <div
        className="SettingBody-head"
        style={{ borderBottom: "1px solid lightgray" }}
      >
        <Link to={"/setting/"}>
          <ArrowBackIcon sx={{ scale: 1 }} />
        </Link>
        <p>Payroll Configuration</p>
      </div>
      <div className="payroll-container-body">
        <div className="attendance-settings-left">
          <div
            className="inner-div"
            style={{ borderBottom: "1px dotted lightgray" }}
          >
            <Form>
              <Row>
                <Col sm="3">
                  <label style={{ marginTop: "8px", whiteSpace: "nowrap" }}>
                    Calendar Month
                  </label>
                </Col>
                <Col sm="6" style={{ paddingRight: 0 }}>
                  <div
                    className={`wrapper_dropdown ${isOpen ? "active" : null } `}
                    id="dropdown"
                    onClick={dropdownFunc}
                  >
                    <span
                      className="selected-display"
                      id="destination"
                      style={{ color: "gray" }}
                    >
                      Select calendar month
                    </span>
                    <svg
                      id="drp-arrow"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="arrow transition-all ml-auto rotate-180"
                    >
                      <path
                        d="M7 14.5l5-5 5 5"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>

                    {isOpen && (
                      <ul className="dropdown">
                        {Array.isArray(calendarMonthList) &&
                          calendarMonthList.map((row, idx) => {
                            return (
                              <li
                                className="item"
                                key={idx}
                                style={{
                                  borderBottom: "1px solid lightgray",
                                }}
                                onClick={() =>
                                  handleCalendarMonthList(
                                    row.calendarId,
                                    row.month_name
                                  )
                                }
                              >
                                <div>{row.month_name} </div>
                                <div
                                  style={{
                                    marginTop: "-30px",
                                    fontSize: "12px",
                                    color: "gray",
                                  }}
                                >
                                  {row.month_subtext}
                                </div>
                              </li>
                            );
                          })}
                      </ul>
                    )}
                  </div>
                </Col>
                <Col sm="3" className="right-left-align">
                  <ButtonCom
                    type={"button"}
                    class_name={"p_btn"}
                    text="Update"
                    url_or_onclick={() => {}}
                    icon={null}
                    width={""}
                  />
                </Col>
              </Row>
            </Form>
          </div>
        </div>

        <div className="attendance-settings-left">
          <div className="inner-div">
            <Row>
              <Col sm="3">
                <label style={{ whiteSpace: "nowrap" }}>
                  Attendance Cycles
                </label>
              </Col>
              <Col sm="6" style={{ paddingRight: 0, color: "gray" }}>
                <select className="option_dropdown">
                  <option value="option1"> 1</option>
                  <option value="option2"> 2</option>
                  <option value="option3"> 3</option>
                </select>
              </Col>
              <Col sm="3" className="right-left-align">
                <ButtonCom
                  type="button"
                  class_name={"p_btn"}
                  text="Add +"
                  icon={null}
                  width="95px"
                />
              </Col>
            </Row>
          </div>
        </div>

        <div className="attendance-settings-left">
          <div
            className="inner-div"
            style={{ borderBottom: "1px dotted lightgray" }}
          >
            <Form>
              <Row>
                <Col sm="3">
                  <label style={{ whiteSpace: "nowrap" }}>Start Date</label>
                </Col>
                <Col
                  sm="6"
                  style={{ paddingRight: 0 }}
                  className="flex-justify-center align-items-center"
                >
                   <p> from</p>
                  {(() => {
                    const rows = [];
                    for (let i = 1; i < 32; i++) {
                      rows.push(
                        <option value={i} key={i}>
                          {i}
                        </option>
                      );
                    }

                    return (
                      <Form.Select
                        id="width-70-px"
                        onChange={handleStartDate}
                        style={{ color: "gray" }}
                      >
                        {rows}
                      </Form.Select>
                    );
                  })()}

                  <p> to</p>

                  <Form.Control
                    placeholder="0"
                    id="width-70-px"
                    className="start-date"
                    value={31}
                    readOnly
                  />
                </Col>
                <Col sm="3" className="right-left-align">
                  <ButtonCom
                    type="button"
                    class_name={"p_btn"}
                    text="Update"
                    url_or_onclick={() => {}}
                    icon={null}
                    width={""}
                  />
                </Col>
              </Row>
            </Form>
          </div>
        </div>

        <div className="attendance-settings-left">
          <div
            className="inner-div"
            style={{ borderBottom: "1px dotted lightgray" }}
          >
            <Form>
              <Row>
                <Col sm="3">
                  <Form.Label>Regularization Period</Form.Label>
                </Col>
                <Col sm="6" style={{ paddingRight: 0 }}>
                  <select
                    className="option_dropdown"
                    name="regularization"
                    style={{ color: "gray" }}
                  >
                    <option value="1"> 1 day</option>
                    <option value="2"> 2 days</option>
                  </select>
                </Col>
                <Col sm="3"></Col>
              </Row>
            </Form>
          </div>
        </div>

        <div className="attendance-settings-left">
          <div className="inner-div">
            <Form>
              <Row>
                <Col sm="3">
                  <Form.Label>Probation Leave Rules</Form.Label>
                </Col>
                <Col sm="6" style={{ paddingRight: 0 }}>
                  <Form.Control placeholder="Enter probation rules" />
                </Col>
                <Col sm="3" className="right-left-align">
                  <ButtonCom
                    type="button"
                    class_name={"p_btn"}
                    text="Update"
                    url_or_onclick={() => {}}
                    icon={null}
                    width={""}
                  />
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
